import './Footer.css';
import '../../styles/Shared.css';
import '../../styles/Neo.css';

import {VersionNumber} from '../../data_layer/data/VersionNumber';
import { useEffect, useState } from 'react';

function Footer() {

  const [date, setDate] = useState();

    useEffect(() => {
      getYear()
    }, []);
    

    const getYear = () => {
        const today = new Date();
        setDate(today.getFullYear());
    }

  return (
      <footer className="d-flex align-items-center bg-white p-2">
          <img className=''
            src={require('../../assets/Neoneuro-FF.png')}
            alt="Neoneur Logo"
          />
          {/* <a className='FooterButton' href='https://neoneur.com/privacy/'>Privacy policy</a>
          <a className='FooterButton' href='https://neoneur.com/terms/'>Terms</a> */}
          <label className='ms-auto me-4 FooterLabel'>Version {VersionNumber}</label>
          <label className='me-4 FooterLabel'>© {date} Neoneur. All rights reserved.</label>
      </footer>
  );
}

export default Footer;